import React, { useEffect, useState } from "react";
import { SITE_TITLE } from '../../utils/constants';
import { seo } from '../../utils/seo';
import useAuth from '../../hooks/useAuth';
import './techtop-training.css';
import MotorTrainingTab from "./tabs/motor-training";
import VideosTab from "./tabs/videos";
import InformationStationTab from "./tabs/information-station";
import FishbowlTraining from "./tabs/fishbowl-training";

const TechtopTrainingPage = () => {
    const { user, updateCustomers } = useAuth();
    const [activeTab, setActiveTab] = useState('motor-training');

    useEffect(() => {
        seo({
            title: SITE_TITLE + ' || Techtop Training',
            metaDescription: '',
        });
    }, [user]);

    const renderTabLists = () => {
        return (
            <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item">
                    <button 
                        className={`nav-link ${activeTab === 'motor-training' ? 'active' : ''}`}
                        onClick={() => setActiveTab('motor-training')}
                    >
                        Motor Training
                    </button>
                </li>
                <li className="nav-item">
                    <button 
                        className={`nav-link ${activeTab === 'videos' ? 'active' : ''}`}
                        onClick={() => setActiveTab('videos')}
                    >
                        Videos
                    </button>
                </li>
                <li className="nav-item">
                    <button 
                        className={`nav-link ${activeTab === 'information-station' ? 'active' : ''}`}
                        onClick={() => setActiveTab('information-station')}
                    >
                        Information Station
                    </button>
                </li>
                <li className="nav-item">
                    <button 
                        className={`nav-link ${activeTab === 'fishbowl-training' ? 'active' : ''}`}
                        onClick={() => setActiveTab('fishbowl-training')}
                    >
                        Fishbowl Training
                    </button>
                </li>
            </ul>
        )
    }

    const renderTabs = () => {
        return (
            <React.Fragment>
                <MotorTrainingTab 
                    key={activeTab === 'motor-training' ? 'motor-training' : ''}
                    active={activeTab === 'motor-training'}
                />
                <VideosTab 
                    key={activeTab === 'videos' ? 'videos' : ''}
                    active={activeTab === 'videos'}
                />
                <InformationStationTab 
                    key={activeTab === 'information-station' ? 'information-station' : ''}
                    active={activeTab === 'information-station'}
                />
                <FishbowlTraining 
                    key={activeTab === 'fishbowl-training' ? 'fishbowl-training' : ''}
                    active={activeTab === 'fishbowl-training'}
                />
            </React.Fragment>

        )
    }
    return (
        <React.Fragment>
            <main className="techtop-middle-div">
                <section className="techtop-traning-section pb-5">	
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="techtop-default-title2">
                                    <div className="row">
                                        <div className="col-12">	
                                            <h1 className="m-0 dark-color2">Techtop Training</h1>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12" id="techtop-training-tabs">
                                        <div className="row">
                                            <div class="col-md-12 mobile-view">
                                                {renderTabLists()}
                                            </div>
                                            <div className="col-md-10">
                                                <div className="tab-content">
                                                    {renderTabs()}
                                                </div>
                                            </div>
                                            <div className="col-md-2 text-end desktop-view">
                                                {renderTabLists()}
                                            </div>
                                            
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </React.Fragment>
    );
};

export default TechtopTrainingPage;